import { render, staticRenderFns } from "./CopyBox.vue?vue&type=template&id=79722dee&scoped=true"
import script from "./CopyBox.vue?vue&type=script&lang=js"
export * from "./CopyBox.vue?vue&type=script&lang=js"
import style0 from "./CopyBox.vue?vue&type=style&index=0&id=79722dee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79722dee",
  null
  
)

export default component.exports